import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { logout, getUser, refreshUser } from '../services/auth';
import Icon from './Icon';
import './Icon.css';
import './Layout.css';

const navItems = [
  { to: '/', label: 'Home', icon: 'home' },
  { to: '/jogos', label: 'Jogos', icon: 'ball' },
  { to: '/palpites', label: 'Palpites', icon: 'list' },
  { to: '/ranking', label: 'Ranking', icon: 'bars' },
  { to: '/premiacoes', label: 'Prêmios', icon: 'gift' },
  { to: '/perfil', label: 'Perfil', icon: 'user' },
];

export default function Layout() {
  const navigate = useNavigate();
  const [user, setUser] = useState(getUser());

  useEffect(() => {
    refreshUser().then(setUser).catch(() => {});
  }, []);

  function handleLogout() {
    logout();
    navigate('/login');
  }

  const bloqueado = user?.bloqueado;

  return (
    <div className="layout">
      <header className="topbar">
        <div className="topbar-brand">
          <span className="topbar-logo"><Icon name="ball" size={20} /></span>
          <span className="topbar-title">Palpitar</span>
        </div>
        <div className="topbar-right">
          {user?.tipo_usuario === 'admin' && (
            <button className="btn-admin" onClick={() => navigate('/admin')}>Admin</button>
          )}
          <button className="btn-logout" onClick={handleLogout}>Sair</button>
        </div>
      </header>

      {bloqueado ? (
        <div className="banner-inadimplente">
          <span>Conta com pendência de pagamento.</span>
          <button className="btn-banner-pix" onClick={() => navigate('/comprovante')}>
            Enviar Comprovante PIX
          </button>
        </div>
      ) : null}

      <main className={`main-content${bloqueado ? ' with-banner' : ''}`}>
        <div className="container">
          <Outlet context={{ user, setUser }} />
        </div>
      </main>
      <nav className="bottom-nav">
        {navItems.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
          >
            <span className="nav-icon"><Icon name={item.icon} size={20} /></span>
            <span className="nav-label">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
